export function parseMessageData<T>(data: string | undefined): T | null {
  try {
    if (data) {
      return JSON.parse(data) as T;
    }
  } catch {
    return null;
  }
  return null;
}

export function isMessageHidden(data: string | undefined): boolean {
  return parseMessageData<{ hidden?: boolean }>(data)?.hidden === true;
}
